import {TabsPanel} from "@components/interface/TabsPanel";
import React, {CSSProperties, ReactElement, useState} from "react";
import {TileButton} from "@components/interface/TileButton";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";

const styles: Record<string, CSSProperties> = {
    tabs: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0
    },
    tabsHeaders: {
        borderBottomColor: "#c8b89a",
        borderBottomStyle: "solid",
        borderBottomWidth: 2,
        display: "flex",
        flexDirection: "row",
        marginBottom: 8,
    },
    tabPanel: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0
    },
    tabSelect: {
        cursor: "pointer",
        fontFamily: "Georgia, 'Palatino Linotype', serif",
        margin: 4,
        padding: "4px 8px"
    },
    tabActive: {
        borderBottom: "3px solid #2d5a1b",
        color: "#2d5a1b",
        marginBottom: -2
    },
    tabInactive: {
        color: "#8b6914"
    }
};

interface ITabs {
    children: ReactElement | (ReactElement | undefined)[]
    initial?: string
}
export function Tabs({children, initial}: ITabs) {
    const panels = (Array.isArray(children) ? children : [children])
        .filter(child => child)
        .filter(child => child!.type === TabsPanel) as ReactElement[];
    const labels = panels.map(panel => panel.props.label);
    const [selected, setSelected] =
        useState(initial ? labels.indexOf(initial) : 0);

    const handleTabSelect = (selected: number) => () => setSelected(selected)

    return (
        <div style={styles.tabs}>
            <div style={styles.tabsHeaders}>
                {labels.map((label, index) =>
                    <div key={index} onClick={handleTabSelect(index)} style={{
                        ...styles.tabSelect,
                        ...(index === selected ? styles.tabActive : styles.tabInactive),
                        fontWeight: index === selected ? "bold" : "normal"
                    }}>
                        <LocalisedTypography content={label}/>
                    </div>)}
            </div>
            {panels.map((panel, index) => 
                <div key={index} style={{
                    ...styles.tabPanel,
                    display: index === selected ? "flex" : "none"
                }}>
                    {panel}
                </div>
            )}
        </div>
    );
}